import React, { useState } from "react";
import "./Register.css";
import {Api} from "../../Api.js"
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const RegistrationForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    gender: "",
    plan_id:"",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

 const handleSubmit = async (e) => {
  e.preventDefault();

  // Convert plan_id to integer
  const updatedData = {
    ...formData,
    plan_id: parseInt(formData.plan_id, 10)
  };

  console.log("Final Data Sent:", updatedData);

  try {
    const response = await Api.post("/submit-gym-admission", updatedData);
    console.log("Response After Booking:", response.data);
    if(response.status===200){
       toast.success(`Registration Successful!\nWelcome, ${formData.name}! 💪`);
  setFormData({
     name: "",
    email: "",
    phone: "",
    gender: "",
    plan_id:"",
  })
  navigate("/profile");
    }
  } catch (err) {
    console.log("Error Posting Booking Data:", err);
  }


};


  return (
    <div className="register-page">
      <div className="form-container">
        <h1 className="form-title">Join Dhanushdhari Burnout Gym</h1>
        <p className="form-subtitle">
          Transform your body, elevate your mindset. Start your fitness journey
          today.
        </p>

        <form onSubmit={handleSubmit} className="register-form">
          <input
            type="text"
            name="name"
            placeholder="Full Name"
            value={formData.name}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleChange}
            required
          />

          <select name="gender" value={formData.gender} onChange={handleChange} required>
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>

          <select name="plan_id" value={formData.plan_id} onChange={handleChange} required>
            <option value="">Choose Membership Plan</option>
            <option value="1">Basic - ₹2,500</option>
            <option value="2">Premium - ₹4,500</option>
            <option value="3">Pro - ₹6,500</option>
          </select>

          <button type="submit">Register Now</button>
        </form>
      </div>
    </div>
  );
};

export default RegistrationForm;
